import React from 'react';

const Input = ({type,onKeyUp,onChange,id = "Input"}) => {
    return(
        <input type={type} 
        className="form-control" 
        id={id} 
        aria-describedby="Help" 
        onKeyUp={onKeyUp}
        onChange={onChange}
        />
    )
}

export default Input;

